/* eslint-disable no-void */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect } from "react";
import { IconButton, type IconButtonProps } from "@mui/material";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { makeStyles } from "@material-ui/styles";
import { FiChevronDown, FiX } from "react-icons/fi";
import * as Styles from "./select.styles";

interface Props extends IconButtonProps {
  onChange: any;
  data: any[];
  limitResult?: number;
  value: any;
  isError?: boolean;
  clearIcon?: boolean;
  helperText?: string;
  placeholder?: string;
  isMultitple?: boolean;
  marginRightProps?: number;
  iconButton?: any;
  href?: any;
  disabled?: boolean | undefined;
  selectedObj?: (val: any) => void;
}

const useStyles = makeStyles((theme: any) => ({
  select: {
    borderRadius: 8,
    height: 45,
  },
}));

export const SelectMultipleComponent: React.FC<Props> = (
  props: Props,
  ...rest
) => {
  const classes = useStyles();

  useEffect(() => {
    void onHandleChange();
  }, [props.value, props?.data]);

  const onHandleChange = async () => {
    const selectedOption = await props?.data?.find(
      (option) => option?.value === props.value
    );

    if (props.selectedObj && selectedOption) {
      props.selectedObj(selectedOption);
    }
  };

  return (
    <Styles.Container>
      <Styles.Row>
        <Styles.LightText color="#333" fontSize={14}>
          {props.placeholder}
        </Styles.LightText>
        {props.iconButton !== null ? (
          <IconButton href={props.href} target="_blank" size="small" {...rest}>
            {props.iconButton}
          </IconButton>
        ) : null}
      </Styles.Row>

      <Styles.SpaceY space={8} />
      <Select
        endAdornment={
          <FiChevronDown size={28} style={{ marginRight: 8 }} color="#666" />
        }
        multiple
        IconComponent={() =>
          props.value && props.clearIcon ? (
            <>
              <IconButton
                onClick={() => {
                  props.onChange([]);
                }}
              >
                <FiX size={20} style={{ marginRight: 8 }} color="#666" />
              </IconButton>
            </>
          ) : (
            <></>
          )
        }
        className={classes.select}
        value={props.value}
        onChange={(event) => {
          props.onChange(event?.target?.value);
        }}
        size="small"
        disabled={props.disabled}
        sx={{
          backgroundColor: props.disabled ? "rgba(0,0,0,0.08)" : "#ffffff",
          "&:hover": {
            cursor: props.disabled ? "not-allowed" : "pointer",
          },
          "::selection": {
            color: "#333",
          },
        }}
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: 48 * 4.5 + 8,
              width: 250,
            },
          },
        }}
      >
        {props?.data?.map((item: any) => (
          <MenuItem key={item.value} value={item.value}>
            {item.label}
          </MenuItem>
        ))}
      </Select>
    </Styles.Container>
  );
};

SelectMultipleComponent.defaultProps = {
  iconButton: null,
  disabled: false,
};
